import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ActivityItem', {
    grnDescription: 'Has changed the goods received status to {status}',
    grnNotReceived: 'Not received',
    grnPartiallyReceived: 'Partially received',
    grnFullyReceived: 'Fully received',
    onBehalfOfDisplayName: '{author} on behalf of {onBehalfOf}',
});
